/* assets/popup-handler.js — 2. ürüne %40 popup, tüm ürünler, tek seferlik */
(function () {
  // ====== KAMPANYA AYARLARI ======
  const POPUP_IMAGE_URL =
    "https://cdn.shopify.com/s/files/1/0751/9145/1862/files/20_sale_pop_up_copy.jpg?v=1783328496";

  // Sepette toplam kaç ürün varken popup açılsın?
  const TRIGGER_CART_QTY = 1;

  // Bu key'i yeni kampanyalarda v2, v3 diye değiştirirsen eski kullanıcılar tekrar görebilir.
  const STORAGE_KEY_SEEN = "bogo40.popup.seen.v1";

  const FOCUS_POLL = true;

  const ls = window.localStorage;

  // ====== UYGUN MÜŞTERİ KONTROLÜ ======
  function isEligibleVisitor() {
    const cfg = window.BogoCampaignEligibility;

    // Bu config yoksa güvenli davran: popup gösterme.
    // Çünkü logged-in müşterinin tag bilgisini bilemeyiz.
    if (!cfg) return false;

    const loggedIn = cfg.loggedIn === true;

    const tags = Array.isArray(cfg.tags)
      ? cfg.tags.map((t) => String(t).trim().toLowerCase())
      : [];

    const hasCustomerTag = tags.includes("customer");

    // Login olmayanlara görünsün.
    if (!loggedIn) return true;

    // Login olmuşsa sadece Customer tag'i olanlara görünsün.
    return hasCustomerTag;
  }

  function hasSeenPopup() {
    return ls.getItem(STORAGE_KEY_SEEN) === "1";
  }

  function markPopupSeen() {
    ls.setItem(STORAGE_KEY_SEEN, "1");
  }

  // ====== POPUP UI ======
  function ensurePopup() {
    if (document.getElementById("bogo-campaign-popup")) return;

    const wrap = document.createElement("div");
    wrap.id = "bogo-campaign-popup";
wrap.style.cssText =
  "position:fixed;inset:0;z-index:2147483647;display:none;align-items:center;justify-content:center;padding:18px;box-sizing:border-box;background:rgba(12,12,12,.62);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);";

   wrap.innerHTML = `
  <div style="position:relative;max-width:min(92vw,520px);width:100%;border-radius:18px;overflow:hidden;background:#fff;box-shadow:0 24px 80px rgba(0,0,0,.38)">
    <button id="bogo-close" aria-label="Close" style="position:absolute;right:10px;top:10px;width:28px;height:28px;border:none;border-radius:999px;background:rgba(255,255,255,.86);color:#171717;cursor:pointer;font-size:18px;font-weight:300;line-height:1;z-index:2;display:flex;align-items:center;justify-content:center;box-shadow:0 6px 18px rgba(0,0,0,.18);transition:transform .16s ease,background .16s ease,box-shadow .16s ease,opacity .16s ease;">×</button>

    <img
      src="${POPUP_IMAGE_URL}"
      alt="Buy One, Get The Second 40% Off"
      style="display:block;width:100%;height:auto"
    >
  </div>
`;

    document.body.appendChild(wrap);

    wrap.addEventListener("click", (e) => {
      if (e.target.id === "bogo-campaign-popup") hidePopup();
    });

    document.getElementById("bogo-close").addEventListener("click", hidePopup);
    const closeBtn = document.getElementById("bogo-close");

closeBtn.addEventListener("mouseenter", () => {
  closeBtn.style.transform = "scale(1.04)";
  closeBtn.style.background = "#ffffff";
  closeBtn.style.boxShadow = "0 8px 22px rgba(0,0,0,.22)";
});

closeBtn.addEventListener("mouseleave", () => {
  closeBtn.style.transform = "scale(1)";
  closeBtn.style.background = "rgba(255,255,255,.86)";
  closeBtn.style.boxShadow = "0 6px 18px rgba(0,0,0,.18)";
});
  }

  function showPopup() {
    if (hasSeenPopup()) return;
    if (!isEligibleVisitor()) return;

    ensurePopup();

    const popup = document.getElementById("bogo-campaign-popup");
    if (!popup) return;

    popup.style.display = "flex";

    // Bir kere gördüyse artık tekrar çıkmasın.
    markPopupSeen();

    document.dispatchEvent(new CustomEvent("bogo:popup-open"));
  }

  function hidePopup() {
    const el = document.getElementById("bogo-campaign-popup");
    if (el) el.style.display = "none";

    // Kullanıcı kapattıysa da kesin olarak tekrar çıkmasın.
    markPopupSeen();

    document.dispatchEvent(new CustomEvent("bogo:popup-close"));
  }

  // ====== SEPET ======
  async function fetchJSON(url, init = {}) {
    const res = await fetch(url, {
      ...init,
      credentials: "same-origin"
    });

    if (!res.ok) throw new Error("HTTP " + res.status + " @ " + url);
    return res.json();
  }

  async function getCart() {
    return fetchJSON("/cart.js");
  }

  function getCartQuantity(cart) {
    if (typeof cart.item_count === "number") return cart.item_count;

    const items = Array.isArray(cart.items) ? cart.items : [];
    return items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  }

  function isCartMutationURL(u) {
    if (typeof u !== "string") return false;
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(u);
  }

  let refreshTimer = null;

  function scheduleRefresh(delay = 150) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(evaluate, delay);
  }

  // ====== ANA AKIŞ ======
  async function evaluate() {
    try {
      if (hasSeenPopup()) return;
      if (!isEligibleVisitor()) return;

      const cart = await getCart();
      const totalQty = getCartQuantity(cart);

      if (totalQty === TRIGGER_CART_QTY) {
        showPopup();
      }

      document.dispatchEvent(
        new CustomEvent("bogo:campaign-updated", {
          detail: {
            totalQty,
            triggerQty: TRIGGER_CART_QTY,
            eligibleVisitor: isEligibleVisitor(),
            seen: hasSeenPopup()
          }
        })
      );
    } catch (_) {}
  }

  // ====== FETCH PATCH ======
  const _fetch = window.fetch;

  window.fetch = async function patchedFetch(input, init) {
    const resp = await _fetch(input, init);

    try {
      const url =
        typeof input === "string" ? input : (input && input.url) || "";

      if (resp.ok && isCartMutationURL(url)) {
        scheduleRefresh(120);
      }
    } catch (_) {}

    return resp;
  };

  // ====== XHR PATCH ======
  const OrigXHR = window.XMLHttpRequest;

  function XHRProxy() {
    const xhr = new OrigXHR();
    const _open = xhr.open;

    xhr.open = function (method, url) {
      this.__bogoIsMutation = isCartMutationURL(
        typeof url === "string" ? url : ""
      );

      return _open.apply(this, arguments);
    };

    xhr.addEventListener("load", function () {
      if (
        this.__bogoIsMutation &&
        this.status >= 200 &&
        this.status < 300
      ) {
        scheduleRefresh(120);
      }
    });

    return xhr;
  }

  window.XMLHttpRequest = XHRProxy;

  // Tema/app sepet eventleri
  ["cart:updated", "product:added", "variant:added", "line:updated"].forEach(
    (ev) => {
      document.addEventListener(ev, () => scheduleRefresh(60), {
        passive: true
      });
    }
  );

  window.addEventListener("load", () => evaluate());

  if (FOCUS_POLL) {
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) scheduleRefresh(0);
    });

    window.addEventListener("pageshow", () => scheduleRefresh(0));
  }

  // Test/debug için
  window.BogoCampaign = {
    refresh: () => scheduleRefresh(0),
    open: showPopup,
    close: hidePopup,
    resetSeen: () => ls.removeItem(STORAGE_KEY_SEEN)
  };
})();